export default __webpack_public_path__ + "static/media/esa-logo.20da1254.svg";